import Vue from 'vue'
import App from './App.vue'
import filters from '@/filters'
import i18n from '@/services/i18n'
import Toast from '@/plugins/toast'
import DynamicAssign from '@/plugins/dynamicAssign'
import { Debug } from '@/components'

Vue.config.productionTip = false

Vue.use(filters)
Vue.use(Toast)
Vue.use(DynamicAssign)

new Vue({
   i18n,
   components: {
      Debug,
   },
   render: h => h(App),
}).$mount('#app')
